var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwipe = function SvgSwipe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.031 6.983c.495 0 .91.414.91.925V8.96a4.539 4.539 0 0 1-4.532 4.532l-4.739-.001v1.325c0 .303-.16.59-.43.734a.862.862 0 0 1-.4.096.762.762 0 0 1-.447-.128l-3.51-2.25a.837.837 0 0 1 0-1.404l3.51-2.25a.838.838 0 0 1 .862-.032c.271.144.43.431.43.734v1.34l4.724.001a2.703 2.703 0 0 0 2.697-2.696V7.908c0-.51.415-.926.925-.926ZM10.457.599a.872.872 0 0 1 .862.031l3.51 2.25c.24.16.384.432.383.72a.837.837 0 0 1-.383.701l-3.51 2.25a.859.859 0 0 1-.846.032.827.827 0 0 1-.43-.734V4.493H5.319a2.703 2.703 0 0 0-2.697 2.696v1.054a.927.927 0 0 1-1.85 0V7.189a4.539 4.539 0 0 1 4.53-4.531h4.725V1.333c0-.304.159-.591.43-.734Z",
    fill: "#292A2C"
  })));
};
export default SvgSwipe;